import React from "react"
import styled from "styled-components"
import { theme } from "Theme"

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  color: ${theme.colors.white.base};
  background: ${theme.colors.black.base};
  z-index: 999;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  opacity: 0.9;
  svg {
    height: 100px;
  }
`

const LoadingSpinner = () => (
  <Wrapper>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24px"
      height="30px"
      viewBox="0 0 24 30"
      style={{ enableBackground: "new 0 0 50 50" }}>
      <rect x="0" y="13" width="4" height="5" fill={`${theme.colors.primary.base}`}>
        <animate
          attributeName="height"
          attributeType="XML"
          values="5;21;5"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="13; 5; 13"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="10" y="13" width="4" height="5" fill={`${theme.colors.primary.base}`}>
        <animate
          attributeName="height"
          attributeType="XML"
          values="5;21;5"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="13; 5; 13"
          begin="0.15s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="20" y="13" width="4" height="5" fill={`${theme.colors.primary.base}`}>
        <animate
          attributeName="height"
          attributeType="XML"
          values="5;21;5"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="13; 5; 13"
          begin="0.3s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
    <span style={{ margin: "0 10px" }}> Loading...</span>
  </Wrapper>
)

export default LoadingSpinner
